<mat-card class="panel_search mat-card">
  <!--sub header-->
  <div class="panel_sub_header">
      <span class="panel__header__title">Add Component Testing Point Images</span>
  </div>
  <h1 style="display:none" mat-dialog-title> {{data.compartid_auto}}</h1>
  <span *ngIf="isStandard==true"  style="font-weight: bold;">Component Type Standard Image</span>
  <form class="header-form">
    <mat-form-field>
        <mat-select placeholder="Select Tool" name="tool_auto_" [(ngModel)]="tool_auto" #tool_auto_="ngModel" (selectionChange)="changeAttachImage()"required>
            <mat-option [value]="type.ToolId" *ngFor="let type of _componentservice.measurementToolsList">
                {{type.ToolName}}
            </mat-option>
        </mat-select>
        <mat-error>Please select a Tool Used</mat-error>
    </mat-form-field>



</form>
  <img style="width:100px; height:100px" *ngIf="attachment" [src]="sanitize(attachment)">

  <div class="upload-container"  title="{{'Add photo' | translate | async}}">
      <i class="material-icons upload-container__icon">
          add_a_photo
      </i>
         <input type="file" accept="image/*" (change)="onSelectPhoto($event)" > 
   </div>

  

  <div mat-dialog-actions>
      <button mat-button class="button button--primary" (click)="NoClick()">Cancel <i class="material-icons button__icon"></i><span
              class="button__text"></span></button>
      <button mat-button class="button button--primary" (click)="saveCompTestingPointtImageDialog()" cdkFocusInitial>Save <i class="material-icons button__icon"></i><span
              class="button__text"></span></button>
  </div>
</mat-card>